/**
legend
*/


<template>
    <div class="sidebar-legend">
        <div v-for="layer in mapLayers">
            <div v-if="!layer.is_group && !layer.legend_below_title">
                <basic-legend-item v-bind:layer="layer" v-on:layer-change="toggleLayer"/>
            </div>

            <div v-if="!layer.is_group && layer.legend_below_title">
                <legend-with-title v-bind:layer="layer" v-on:layer-change="toggleLayer"/>
            </div>

            <div v-if="layer.is_group && !layer.is_additional_activity_group">
                <legend-with-dropdown v-bind:layer="layer" v-on:layer-change="toggleLayer"/>
            </div>

<!--            <div v-if="layer.is_additional_activity_group">-->
<!--                <additional-activities-legend v-bind:additional-activities-data="layer" v-on:layer-change="toggleLayer"/>-->
<!--            </div>-->
        </div>

        <additional-activities-legend/>

    </div>
</template>


<script>
import store from "../store/reality-check-store";
import BasicLegendItem from "./basic-legend-item.vue";
import LegendWithTitle from "./legend-with-title.vue";
import LegendWithDropdown from "./legend-with-dropdown.vue";
import AdditionalActivitiesLegend from "./additional-activities-legend.vue";


export default {
    name: "main-map-legend",
    components: {
        BasicLegendItem, LegendWithTitle, LegendWithDropdown, AdditionalActivitiesLegend
    },
    store,
    props: {},
    data: function () {
        return {
            mapLayers: mparc.mapLayers,
        }
    },
    methods: {
        toggleLayer: function (e) {
            // These events are collated here to keep things obvious, rather than the small components interacting with the store
            if (e[0] === "single") {
                this.$store.commit("toggleSingleMapLayer", [e[1], e[2]])
                return
            }

            // Group layer. Event is ["group", layers to turn on, layers to turn off]
            if (e[0] === "dropdown-group") {
                this.$store.dispatch("updateDropdownGroupLayers", [e[1], e[2]])
                return
            }

            // if (e[0] === "additional-activities") {
            //     console.log("IMPLEMENT THIS!!!")
            // }

            // console.log('layer change', e)
        }
    },
    computed: {},
    watch: {},
    mounted: function () {
    }
}
</script>


<style lang="scss">
    @import "../../../styles/variables";

    .sidebar-legend {
        background-color: white;
        border-radius: 0.25rem;
        margin: 14px 0;
        padding: 3px;

        font-size: 72%;
    }

    .legend-checkbox {
        margin-left: 3px;
        border-width: 1px !important;
    }
</style>